import React from 'react';
import { CustomSwitch } from 'common/components/CustomSwitch/CustomSwitch';

import './ThreatCenterTopBar.scss';
import { Text } from '@cyberpion/cyberpion-ui';
import { ThreatsCenterContextType, useThreatsCenter } from '../ThreatsCenterContext';

const ThreatCenterTopBar = () => {
  const {
    search,
    setSearch,
    showOnlyFindings,
    setShowOnlyFindings,
    setTimelineSelected
  } = useThreatsCenter() as ThreatsCenterContextType;

  const handleSwitch = (e: React.ChangeEvent, isChecked: boolean) => {
    setTimelineSelected(null);
    setShowOnlyFindings(isChecked);
  };

  const handleOnSearch = (e: any) => {
    setTimelineSelected(null);
    setSearch(e.target.value);
  };

  return (
    <div className="ThreatCenterTopBar">
      <div className="Search">
        <img alt="Search" src="/assets/images/search.svg" />
        <input id="input-search" type="text" maxLength={30} value={search} onChange={handleOnSearch} />
      </div>
      <div className="top-bar-switch">
        <Text textColor="#707070" style={{ marginRight: 12 }}>
          Hide threats without findings
        </Text>
        <CustomSwitch checked={showOnlyFindings} onChange={handleSwitch} />
      </div>
    </div>
  );
};

export default ThreatCenterTopBar;
